import { CharField, ImageField, NumberField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Theme } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

const COLOR_OPTIONS = [
  { value: "#79C356", label: "Verde" },
  { value: "#E745F1", label: "Viola" },
  { value: "#FF7C1A", label: "Arancio" },
  { value: "#D8242A", label: "Rosso" },
]

export default function ThemeForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Theme>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.image}
        onChange={(value) => {
          setFieldValue("image", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "image") : undefined}
        errorMessage={getIn(errors, "image")}
        required
      />

      <SingleSelectField
        label="Colore principale"
        layout="horizontal"
        options={COLOR_OPTIONS}
        value={COLOR_OPTIONS.find((type) => type.value === values.main_color) || null}
        onChange={(value) => {
          setFieldValue("main_color", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "main_color") : undefined}
        errorMessage={getIn(errors, "main_color")}
        required
      />

      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.description}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "description") : undefined}
        errorMessage={getIn(errors, "description")}
      />
      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.order}
        onChange={(value) => {
          setFieldValue("order", value)
        }}
      />
    </Col>
  )
}
